import { type ReactElement } from 'react';
import { Icon } from '../Icon/Icon';
import { getAppSettings } from '../Util/globalAppSettings';

export const MapSymbolsReference = ({ region }: { region: string }): ReactElement => {
    const appSettings = getAppSettings();

    return (
        <>
            <h3>Trafikläget</h3>
            <ul className="symbolList list-unstyled">
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_109" />
                    <span>Viktig trafikinformation</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_101" />
                    <span>Olycka</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_104" />
                    <span>Avstängd väg</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_106" />
                    <span>Broöppning</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_107" />
                    <span>Risk för besvärligt väglag</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_105" />
                    <span>Trafikmeddelande</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_103" />
                    <span>Kö</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_141" />
                    <span>Färja med trafikstörning</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_120" />
                    <span>Vägarbete</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_122" />
                    <span>Sprängningsarbete</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_901105" />
                    <span>Cykeltrafik</span>
                </li>
            </ul>
            <h3>Kommande störningar</h3>
            <ul className="symbolList list-unstyled">
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_160" />
                    <span>Avstängd väg</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_164" />
                    <span>Broöppning</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_161" />
                    <span>Trafikmeddelande</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_142" />
                    <span>Färja med trafikstörning</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_162" />
                    <span>Vägarbete</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_165" />
                    <span>Sprängningsarbete</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon" symbol="symbol_951161" />
                    <span>Cykeltrafik</span>
                </li>
            </ul>
            <h3>Kameror</h3>
            <ul className="symbolList list-unstyled">
                <li className="d-flex align-items-center">
                    <Icon className="icon icon--dark" symbol="symbol_camera" />
                    <span>Trafikkamera</span>
                </li>
            </ul>
            <h3>Väder</h3>
            <ul className="symbolList list-unstyled">
                <li className="d-flex align-items-center">
                    <Icon className="icon icon--dark" symbol="precipitationSnow" />
                    <span>Snö</span>
                    <br />
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon icon--dark" symbol="precipitationSleet" />
                    <span>Snöblandat regn</span>
                    <br />
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon icon--dark" symbol="precipitationFreezingRain" />
                    <span>Underkylt regn</span>
                    <br />
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon icon--dark" symbol="precipitationRain" />
                    <span>Regn</span>
                    <br />
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon icon--dark" symbol="precipitationNoData" />
                    <span>Ingen uppgift</span>
                    <br />
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon icon--dark" symbol="precipitationNoPrecipitation" />
                    <span>Ingen nederbörd</span>
                </li>
            </ul>
            {region.toLowerCase() === 'gbg' && (
                <>
                    <h3>Parkering</h3>
                    <ul className="symbolList list-unstyled">
                        <li className="d-flex align-items-center">
                            <Icon className="icon" symbol="symbol_208" />
                            <span>Pendelparkering</span>
                        </li>
                        <li className="d-flex align-items-center">
                            <Icon className="icon" symbol="symbol_210" />
                            <span>Parkering</span>
                        </li>
                        <li className="d-flex align-items-center">
                            <Icon className="icon" symbol="symbol_203" />
                            <span>MC-parkering</span>
                        </li>
                        <li className="d-flex align-items-center">
                            <Icon className="icon" symbol="symbol_201" />
                            <span>Rörelsehindrad</span>
                        </li>
                        <li className="d-flex align-items-center">
                            <Icon className="icon" symbol="symbol_204" />
                            <span>Bussparkering</span>
                        </li>
                        <li className="d-flex align-items-center">
                            <Icon className="icon" symbol="symbol_202" />
                            <span>Lastbilsparkering</span>
                        </li>
                    </ul>
                </>
            )}
            {region.toLowerCase() === 'vst' && (
                <>
                    <h3>Parkering</h3>
                    <ul className="symbolList list-unstyled">
                        <li className="d-flex align-items-center">
                            <Icon className="icon" symbol="symbol_203" />
                            <span>MC-parkering</span>
                        </li>
                        <li className="d-flex align-items-center">
                            <Icon className="icon" symbol="symbol_201" />
                            <span>Rörelsehindrad</span>
                        </li>
                        <li className="d-flex align-items-center">
                            <Icon className="icon" symbol="symbol_204" />
                            <span>Bussparkering</span>
                        </li>
                        <li className="d-flex align-items-center">
                            <Icon className="icon" symbol="symbol_202" />
                            <span>Lastbilsparkering</span>
                        </li>
                    </ul>
                </>
            )}
            <h3>Framkomlighet</h3>
            <ul className="symbolList list-unstyled">
                <li className="d-flex align-items-center">
                    <Icon className="icon traffic-symbols__road traffic-symbols--road-freeflow" symbol="road" />
                    <span>Normal framkomlighet</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon traffic-symbols__road traffic-symbols--road-heavy" symbol="road" />
                    <span>Långsam trafik</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon traffic-symbols__road traffic-symbols--road-congested" symbol="road" />
                    <span>Mycket långsam trafik</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon traffic-symbols__road traffic-symbols--road-impossible" symbol="road" />
                    <span>Stillastående trafik</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon traffic-symbols__road traffic-symbols--road-unknown" symbol="road" />
                    <span>Information saknas</span>
                </li>
                {(appSettings.enableClosedRoadLayer || (appSettings.enableTomtomRouteMonitoringApi && appSettings.enableTomtomClosedSections)) && (
                    <li className="d-flex align-items-center">
                        <Icon className="icon traffic-symbols__road traffic-symbols--road-closed" symbol="road" />
                        <span>Avstängd väg</span>
                    </li>
                )}
            </ul>
            <h3>Väglagsinformation</h3>
            <ul className="symbolList list-unstyled">
                <li className="d-flex align-items-center">
                    <Icon className="icon traffic-symbols__road traffic-symbols--road-condition-normal" symbol="road" />
                    <span>Normalt</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon traffic-symbols__road traffic-symbols--road-condition-difficult " symbol="road" />
                    <span>Besvärligt (risk för)</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon traffic-symbols__road traffic-symbols--road-condition-very-difficult" symbol="road" />
                    <span>Mycket besvärligt</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon traffic-symbols__road traffic-symbols--road-condition-ice-snow" symbol="road" />
                    <span>Is- och snövägbana</span>
                </li>
                <li className="d-flex align-items-center">
                    <Icon className="icon traffic-symbols__road traffic-symbols--road-condition-unknown" symbol="road" />
                    <span>Information saknas</span>
                </li>
            </ul>
        </>
    );
};
